// NewsletterPage.jsx

import NewsletterFormComponent from '../../components/modals/web-modals/components/NewsletterFormComponent'; 

const NewsletterPage = () => {
    return (
        <div className="auth-page">
            <div className="auth-card auth-card--wide">
                <NewsletterFormComponent />
            </div>
        </div>
    );
};

export default NewsletterPage;